//todo : refactor (LIT-499196)
//import from Pericles
import './quick-search-core';

UX.quickSearch.submitCitationForm = function ($elem) {
    const mainWrapper = document.querySelector('.citationSearchContainer'),
        form = mainWrapper?.querySelector($elem);

    if (form) {
        const citationSearchWrapper = mainWrapper.querySelector('.citation-search__wrapper'),
            formAlertList = mainWrapper.querySelectorAll('.formAlert'),
            errorMsgText = UX.quickSearch.errorMsgText(),
            inputs = {
                journalHidden: form.querySelector('[name="citationJournal[]"]'),
                journal: form.querySelector('#citationJournal'),
                year: form.querySelector('[name="citationIssueYear"]'),
                volume: form.querySelector('[name="citationVolume"]'),
                issue: form.querySelector('[name="citationIssue"]'),
                page: form.querySelector('[name="citationPage"]'),
                citation: form.querySelector('[name="citationNumber"]'),
            },
            singleInputAlert = el => {
                if (el && el.id) {
                    const elFormAlert = mainWrapper.querySelector(`.formAlert[data-for="${el.id}"]`),
                        elFormLabelText = mainWrapper
                            .querySelector(`label[for="${el.id}"]`)
                            .textContent.toLowerCase()
                            .replace('#', 'number');
                    elFormAlert.textContent = `Error: missing ${elFormLabelText} value`;
                    el.setAttribute('aria-describedby', elFormAlert.id);
                    el.setAttribute('aria-invalid', 'true');
                }
            },
            formErrorMessage = {
                show: message => {
                    const errorMsgEl = citationSearchWrapper.querySelector('.error');
                    errorMsgEl?.remove();
                    citationSearchWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<div class="error" role="alert">${message}</div>`
                    );
                },
                hide: () => {
                    const errorMsgEl = citationSearchWrapper.querySelector('.error');
                    errorMsgEl?.remove();
                },
            },
            loading = {
                show: () => {
                    const loadingEL = mainWrapper.querySelector('.js--loading');
                    if (!loadingEL)
                        mainWrapper.insertAdjacentHTML(
                            'afterbegin',
                            '<div class="js--loading" aria-label="loading results" role="alert"></div>'
                        );
                },
                hide: () => {
                    const loadingEL = mainWrapper.querySelector('.js--loading');
                    if (loadingEL) loadingEL.remove();
                },
            },
            clearInputAlert = () => formAlertList.forEach(item => (item.textContent = ''));

        formErrorMessage.hide();
        clearInputAlert();

        if (!inputs.journalHidden) {
            formErrorMessage.show(errorMsgText.journal);
            singleInputAlert(inputs.journal);
            inputs.journal.focus();
        } else {
            if (UX.utils.isElementEmptyOrSpaces(inputs.volume)) {
                singleInputAlert(inputs.volume);
                singleInputAlert(inputs.page);
                singleInputAlert(inputs.citation);
                setTimeout(() => {
                    inputs.volume.focus();
                    formErrorMessage.show(errorMsgText.default);
                }, 25);
            } else {
                if (UX.utils.isElementEmptyOrSpaces(inputs.page) && UX.utils.isElementEmptyOrSpaces(inputs.citation)) {
                    singleInputAlert(inputs.page);
                    singleInputAlert(inputs.citation);
                    formErrorMessage.show(errorMsgText.default);
                    inputs.page.focus();
                } else {
                    inputs.journalHidden.value = inputs.journalHidden.value.replace(/['"]+/g, '');
                    loading.show();
                    let baseURL = `${window.location.origin}/action/citationSearch?`,
                        urlParams = '',
                        counter = 0;

                    for (const item in inputs) {
                        let separator = counter !== 0 ? '&' : '';
                        if (inputs[item]?.value) {
                            urlParams += `${separator}${inputs[item].name}=${inputs[item].value}`;
                        }
                        counter++;
                    }
                    baseURL += urlParams;
                    fetch(baseURL)
                        .then(response => response.json())
                        .then(data => {
                            loading.hide();
                            if (data.link) {
                                window.location = data.link;
                            } else {
                                const otherCitationSearch = mainWrapper.querySelector('.other-citation-search'),
                                    otherCitationSearchInputs = otherCitationSearch.querySelectorAll('input');

                                otherCitationSearchInputs[0].focus();
                                if (data.error) {
                                    formErrorMessage.show(data.error);
                                } else {
                                    formErrorMessage.show(errorMsgText.server);
                                }
                            }
                        });
                }
            }
        }
    }
};

UX.quickSearch.doSuggest = function () {
    const $citationJournal = $('.citation.magicsuggest'),
        maxWords = $citationJournal.data('max-words'),
        maxChars = $citationJournal.data('max-chars'),
        preVal = $citationJournal.val().split(','),
        preLabel = $citationJournal.data('label'),
        disabledFields = $('#citationSearchForm').find('input[name^="citation"][type="search"]');

    let ms = UX.quickSearch.magicSuggest($citationJournal, maxWords, maxChars);
    ms.input[0]?.setAttribute('aria-required', 'true');
    const $citationSearchContainer = $('.citationSearchContainer'),
        $msInputWrapper = $citationSearchContainer.find('.ms-sel-ctn'),
        $msInput = $msInputWrapper.find('.ms-input');

    if ($citationJournal.hasClass('pre-populated')) {
        ms.setSelection([{value: preVal, label: preLabel}]);
        disabledFields.each(function (e) {
            $(this).removeAttr('disabled');
        });
    }

    $('.ms-trigger').on('click', function () {
        var $triggerParent = $(this).parents('.main-search-field-wrapper'),
            isCitation = $(this).parents().is('.quick-search--citation');

        if (isCitation) {
            $triggerParent.css('overflow', 'visible');
        }
        if ($('.citationJournalName').find('.dropdown-menu').is(':visible')) {
            ms.getValue().length > 0 ? ms.collapse() : ms.expand();
        } else ms.getValue().length > 0 ? ms.expand() : ms.collapse();
    });

    $(ms).on('selectionchange', function (e) {
        $msInput.attr('aria-activedescendant');

        if (this.getSelection().length) {
            disabledFields.each(function (e) {
                $(this).removeAttr('disabled');
            });
        } else {
            disabledFields.each(function (e) {
                $(this).attr('disabled', true).val('');
            });
        }
    });
};

UX.quickSearch.additionalController = function () {
    var qsAdvancedClass = '.quick-search--advanced';
    var $qsAdvancedLinkswrapper = $(qsAdvancedClass).find('.quick-search__links-wrapper');
    var $body = $('body');
    var citationbtn = '.citationSearchContainer .mainSearchButton';

    $(document).on(UX.quickSearch.vPort + '-on', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        UX.quickSearch.isMobile = true;
    });

    $(document).on(UX.quickSearch.vPort + '-off', function () {
        // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
        UX.quickSearch.isMobile = false;
    });

    $body.on('focus', qsAdvancedClass + ' input.autocomplete', function () {
        if (!UX.quickSearch.isMobile && $qsAdvancedLinkswrapper) {
            $(this).addClass('js--focus');
            $qsAdvancedLinkswrapper.slideDown();
            $body.addClass('body-overlay');
        }
    });

    $body.on('click touchstart', function (e) {
        if (!UX.quickSearch.isMobile && $qsAdvancedLinkswrapper && !$(e.target).closest(qsAdvancedClass).length) {
            $(qsAdvancedClass).find('input.js--focus').removeClass('js--focus');
            $qsAdvancedLinkswrapper.slideUp();
            $body.removeClass('body-overlay');
        }
    });

    $body.on('click', citationbtn, function (e) {
        e.preventDefault();
        UX.quickSearch.submitCitationForm('#citationSearchForm');
    });

    $body.on('click', '.quick-search__links-wrapper a', function (e) {
        if (window.location.href.indexOf('/search/advanced') > 0) {
            e.preventDefault();
            if ($(e.target).hasClass('quick-search__citation-search')) {
                $('.tab__citation-search a').click();
            } else {
                $('.advancedSearch__tabs ul>li:first-child a').click();
            }
        }
    });

    $(document).on('keyup', '#citationSearchForm input', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ((e.keyCode || e.which) === 13 && !$(e.target).closest('.ms-sel-ctn').length) {
            UX.quickSearch.submitCitationForm('#citationSearchForm');
        }
    });

    $(window).on('load', function (e) {
        var disabledFields = null;
        if (/publication=/.test(window.location)) {
            disabledFields = $('#citationSearchForm').find('input[name^="citationJournal"][type="search"]');
            disabledFields.each(function (e) {
                $(this).removeAttr('disabled');
            });
        }
    });

    const citationSearchContainer = document.querySelector('.citationSearchContainer');
    if (citationSearchContainer) {
        const magicSuggestWrapper = citationSearchContainer.querySelector('.ms-ctn'),
            magicSuggestInput = magicSuggestWrapper?.querySelector('input[type="text"]');

        if (magicSuggestInput) {
            magicSuggestInput.setAttribute('autocomplete', 'off');
            magicSuggestInput.id = magicSuggestWrapper.id;
            magicSuggestWrapper.removeAttribute('id');
        }
    }
};

UX.quickSearch.magicSuggest = $element => {
    return $element.magicSuggest({
        allowFreeEntries: 'false',
        maxSelection: 1,
        selectFirst: true,
        maxSelectionRenderer: function () {
            return '';
        },
        cls: 'citationJournalName',
        hideTrigger: true,
        placeholder: $element.data('placeholder'),
        maxSuggestions: 5,
        expandOnFocus: false,
    });
};

UX.quickSearch.errorMsgText = function () {
    return {
        default:
            'Please enter a journal title, volume and page number or volume and eLocator as a minimum requirement to run this search.',
        journal: 'Please enter the journal title.',
        server: 'Something went wrong, please try again',
    };
};
